import { overrides } from './overrides';
import { props } from './props';
/**
 * We split out a 'base theme' with just colors
 * and typography so that the props & overrides
 * sections can utilize theme tooling like spacing and
 * palette without creating circular dependencies
 */
import { palette } from './palette';
import { typography } from './typography';
import { createTheme } from '@mui/material';
import { merge, mapValues } from 'lodash';
var theme = createTheme({
    palette: palette,
    typography: typography,
    components: merge(mapValues(props, function (v) { return ({ defaultProps: v }); }), mapValues(overrides, function (v) { return ({ styleOverrides: v }); })),
});
export default theme;
//# sourceMappingURL=theme.js.map